import React, {useState, useEffect} from "react";
import Tab, {TabGroup} from "@amzn/meridian/tab";
import ShipmentInfo from './ShipmentInfo';
import OrderInfo from './OrderInfo';
import OtherAttributes from './OtherAttributes';
import PackageHistory from './PackageHistory';
import Column from "@amzn/meridian/column";
import Loader from "@amzn/meridian/loader";
import {getMockPackageDetailDataForGMDPkg, getPackageDetailData} from "../../../commons/api/GetPackageDetailsResults.js";
import Heading from "@amzn/meridian/heading"
import Row from "@amzn/meridian/row";
import {generateBreadCrumb} from "../BreadCrumbsUtils";
import {FormattedMessage} from "react-intl";
import {DEFAULT_TIMEZONE, FEATURES, GAMEDAY_PACKAGE_ID_PREFIX} from "../../../commons/constants/CommonConstants";
import RefreshTimer from "../../../commons/RefreshTimer";
import {ExceptionView} from "../../../commons/ExceptionView";
import {getFeatureStatus} from "../../../commons/CommonUtils";

export const PackageDetailView = (props) => {
    const [errorMessage, setErrorMessage] = useState(null);
    const [currentTab, setCurrentTab] = useState("ShipmentInfo");
    const [packageDetailData, setPackageDetailData] = useState();
    const [updated, setUpdated] = useState()
    const fetchPackageDetail = async (newTrackingId) => {
        try {
            const isGMDPackageVisibilityEnabled = await getFeatureStatus(FEATURES.IS_GAMEDAY_PACKAGE_HISTORY_VISIBILITY_ENABLED)
            if (isGMDPackageVisibilityEnabled && newTrackingId.startsWith(GAMEDAY_PACKAGE_ID_PREFIX)) {
                console.warn("GMD package visibility enabled, returning mock response for PackageDetailData");
                return getMockPackageDetailDataForGMDPkg();
            }
            return await getPackageDetailData(newTrackingId, props.nodeId);
        } catch (error) {
            setErrorMessage(error)
        }
    }
    useEffect(() => {
        setPackageDetailData(undefined);
        fetchPackageDetail(props.entityDetails.entityIds['trackingId'])
            .then((data) => {
                data.packageDetail.packageData.updateShipmentNotesEnabled = data.updateShipmentNotesEnabled;
                setPackageDetailData(data.packageDetail.packageData);
                setCurrentTab("ShipmentInfo");
            })
            .catch((error) => {
                console.log(error)
            })
    }, [props.entityDetails]);

    return (
        (errorMessage) ? <ExceptionView error={errorMessage} /> :
            <div>
                <Column widths={["grid-5"]} spacingInset="large">
                    {generateBreadCrumb(props.previousPath, "Package Detail")}
                    <Row spacingInset="none none medium">
                        <Heading level={1}><FormattedMessage id="search.package.packageDetail_headerPrefix" defaultMessage="Package" /> {props.packageId}</Heading>
                    </Row>
                    <RefreshTimer deps={[packageDetailData, updated]} />
                    <TabGroup value={currentTab} onChange={setCurrentTab}>
                        <Tab value="ShipmentInfo"><FormattedMessage id="search.package.packageDetail_shipmentInfo" defaultMessage="Shipment Info" /></Tab>
                        <Tab value="OrderInfo"><FormattedMessage id="search.package.packageDetail_orderInfo" defaultMessage="Order Info" /></Tab>
                        <Tab value="OtherAttributes"><FormattedMessage id="search.package.packageDetail_otherAttributes" defaultMessage="Other Attributes" /></Tab>
                        <Tab value="History"><FormattedMessage id="search.package.packageDetail_history" defaultMessage="History" /></Tab>
                    </TabGroup>
                    {packageDetailData === undefined ? <Row spacingInset="large" widths={["grid-2"]}><Column /><Loader /></Row> :
                        currentTab === "ShipmentInfo" ? <ShipmentInfo previousPath={props.previousPath} data={packageDetailData} /> :
                            currentTab === "OrderInfo" ? <OrderInfo previousPath={props.previousPath} data={packageDetailData} /> :
                                currentTab === "OtherAttributes" ? <OtherAttributes previousPath={props.previousPath} data={packageDetailData} /> :
                                    <PackageHistory setUpdated={setUpdated} previousPath={props.previousPath} packageId={props.entityDetails.entityIds['trackingId']} stationTimeZone={packageDetailData.stationTimeZone === null ? DEFAULT_TIMEZONE : packageDetailData.stationTimeZone} />
                    }
                </Column>
            </div>
    )
}





// WEBPACK FOOTER //
// ./src/components/detailPages/packageDetails/PackageDetailView.js